/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-07 19:05:22
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-07 19:48:16
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/local/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';
function getColumns(that) {
	let arr = [
		{
			label: '素材信息',
			type: () => import('./tableCells/materialInCell.vue'),
		},
		{
			label: '素材标签',
			type: () => import('./tableCells/tagCell.vue'),
		},
		{
			key: 'addTime',
			label: '创建时间',
			type: ColumnTypes.TextCell,
		},
		{
			label: '操作',
			key: 'operation',
            type: () => import('./tableCells/opeatorCell.vue'),
            isBatch: that.isBatch,
		},
	];
	return arr;
}

export default getColumns;
